import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b693ed9")

_pushScopeId("data-v-4b693ed9")
const _hoisted_1 = { class: "layered-headings" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "heading" }
const _hoisted_4 = { class: "title front" }
const _hoisted_5 = { class: "title back" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, ({ src, alt, title }) => {
      return (_openBlock(), _createBlock("div", _hoisted_2, [
        _createVNode("img", {
          class: "image",
          src: src,
          alt: alt
        }, null, 8, ["src", "alt"]),
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, _toDisplayString(title), 1),
          _createVNode("h1", _hoisted_5, _toDisplayString(title), 1)
        ])
      ]))
    }), 256))
  ]))
})